import { h } from 'preact';
import PropTypes from 'prop-types';

import UserPreferences from '../../containers/user-preferences/user-preferences';
import {
  userPreferencesActions,
  userPreferencesStore,
} from '../../../global-store/subjects/user-preferences/user-preferences';
import { useSubscribe } from '../../hooks/use-subscribe';

import { useContext } from './use-context';

export const UserPreferencesComponent = ({
  $root,
  htmlProps,
  widget,
  widgetParselyMyTeam,
  widgetParselyMySport,
  widgetParselyMyLocalNews,
  widgetNewsletter,
}) => {
  const userPreferencesState = useSubscribe(userPreferencesStore);

  const { parselyCtx, newslettersCtx, WPNCtx } = useContext({
    htmlProps,
    widget,
    widgetParselyMyTeam,
    widgetParselyMySport,
    widgetParselyMyLocalNews,
    widgetNewsletter,
  });

  return (
    <UserPreferences
      htmlProps={htmlProps}
      widget={widget}
      state={userPreferencesState}
      actions={userPreferencesActions}
      WPNCtx={WPNCtx}
      newslettersCtx={newslettersCtx}
      parselyCtx={parselyCtx}
      $root={$root}
    />
  );
};

UserPreferencesComponent.propTypes = {
  htmlProps: PropTypes.object.isRequired,
  $root: PropTypes.object.isRequired,
  widget: PropTypes.object.isRequired,
  widgetParselyMyTeam: PropTypes.object.isRequired,
  widgetParselyMySport: PropTypes.object.isRequired,
  widgetParselyMyLocalNews: PropTypes.object.isRequired,
  widgetNewsletter: PropTypes.object.isRequired,
};
